import React from 'react';

const SvgStar = props => (
  <svg width="1em" height="1em" viewBox="0 0 30 30" fill="transparent" {...props}>
    <path
      d="M15.857 2.796l-.461-1.032-.454 1.035-.46 1.05-.042.096v.015l-.07.17a571.242 571.242 0 01-1.229 2.84c-.627 1.435-1.312 3-1.674 3.824-1.812.09-6.29.496-7.573.638l-.931.07-.987.073.645.75.61.71h0l.004.005c.077.088.4.39.818.778.435.404 1.01.932 1.626 1.496 1.128 1.033 2.395 2.188 3.196 2.916L7.37 25.903h0l-.22 1.11-.218 1.095.962-.567 1-.59h0l.006-.004 6.54-3.972 6.54 3.963h0l.006.003 1 .59.987.582-.244-1.12-.24-1.094-1.503-7.71c.81-.7 2.069-1.833 3.181-2.851.611-.56 1.18-1.086 1.61-1.489.215-.201.396-.374.53-.504.113-.11.225-.22.281-.29l.608-.737.59-.716-.923-.1-.924-.099h-.003c-1.279-.151-5.771-.55-7.585-.64-.363-.82-1.047-2.383-1.674-3.818l-.94-2.153-.3-.688-.085-.196-.024-.054-.006-.016a.089.089 0 01-.002-.005h0l-.003-.007-.46-1.03z"
      stroke="stroke"
    />
  </svg>
);

export default SvgStar;
